module.exports = __webpack_public_path__ + "static/media/icon.8f4e1adf.png";